import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  IconButton,
  InputAdornment,
  TextField as MUITextField,
  useTheme,
} from "@mui/material";
import { useState } from "react";

export default function MarvyTextField({ type, sx, component, ...props }) {
  const theme = useTheme();
  const [showPassword, setShowPassword] = useState(false);
  const Comp = component || MUITextField;
  return (
    <Comp
      {...props}
      variant="outlined"
      type={showPassword ? "text" : type}
      InputProps={{
        endAdornment:
          type === "password" ? (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
                sx={{
                  color: "rgba(255, 255, 255, 0.5)",
                  outline: "0",
                  [`&:focus`]: {
                    outline: "0",
                    border: "0",
                  },
                }}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ) : null,
      }}
      sx={{
        input: {
          color: "white.main",
          borderRadius: "4px !important",
          // backgroundColor: "dark.main !important",
          [`&:WebkitAutofill,
          &:WebkitAutofill:hover, 
          &:WebkitAutofill:focus, 
          &:WebkitAutofill:active`]: {
            WebkitBoxShadow: `0 0 0 30px ${theme.palette.dark.main} inset !important`,
          },
          "&:WebkitAutofill": {
            WebkitTextFillColor: `${theme.palette.primary.light} !important`,
          },
        },
        label: {
          color: "white.main",
        },
        "& label.Mui-focused": {
          color: "white.main",
        },
        "& .MuiInput-underline:after": {
          borderBottomColor: "primary.main",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "rgba(255, 255, 255, 0.5)",
            borderRadius: "4px",
          },
          "&:hover fieldset": {
            borderColor: "white.main",
            background: "rgba(255, 255, 255, 0.1)",
          },
          "&.Mui-focused fieldset": {
            borderColor: "primary.main",
          },
        },
        ...sx,
      }}
    />
  );
}
